import './styles.scss';

const Label = props => <div className="label">{props.label}</div>;

export default Label;
